module.exports = __webpack_public_path__ + "img/welcome-dark.96c5376e.svg";